module.exports = __webpack_public_path__ + "static/media/a2.8fd8f40.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xubin/a2.mp3
// module id = NP2H
// module chunks = 0